import React, { useState, useEffect } from "react";
import styles from "../../../styles/components/cart.module.scss";
import Loader from "../../Loader";
import _get from "lodash/get";
import {
  sessionTimeOutCheck,
  checkExpiry,
} from "../../../redux/global/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const ModalExample = (props) => {
  //console.log("Props cart ---", props);

 
  const modalRef = React.useRef(null);

  // method to close the modal if clicked outside
  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          //props.closeModal();
        }
      }
      // Bind the event listener
      document.addEventListener("click", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("click", handleClickOutside);
      };
    }, [ref]);
  }
  useOutsideAlerter(modalRef);


  const handledemo = () => {
    props.closeModal();
    document.body.style.overflow = "unset";
  };
  const [Loading, setLoading] = React.useState(false);


  
 
  return (
    <div className={styles.editModalWrapper}>
      {Loading ? (
        <Loader />
      ) : (
        <div className={styles.modalBox} ref={modalRef} style={{height:"190px"}}>
        <div className={`${styles.formContainer}`}>
          <div className="container">
          
            <div className="row">
              <div class="col-md-12">
              <span
                className={styles.rowBtn}
                onClick={() => {
                  handledemo();
                }}
              >
                <div className={styles.icon}>
                    <img src="https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/employeetwin/close.png" className={styles.iconimg}/>
                </div>
              </span>
              </div>
             
            </div>
            </div>
          </div>
         
          <div className={styles.modalBody}>
            
            <div className={styles.row}>
              <div className="col-lg-12 col-md-12 col-12">
                <div className={styles.formGroup}>
                  
                  <div className={styles.formheading}>
                  <h2 className={styles.head} style={{fontSize:"14px"}}>Hi, we have shared the details on your mail. Please Check your email details have been shared</h2>
                  </div>
                </div>
              </div>
            
            </div>
            {/* </div> */}
          </div>
         
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  //console.log("state", state);
  return {
    session: state.session.session,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalExample);

